import { useContext } from "react";
import { AssessmentQuestionContext } from ".";

const useAssessment = () => useContext(AssessmentQuestionContext);

export default useAssessment;
